import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sendForm } from 'shared/common/thunks';
import { EFormStatus, TFormStatus } from 'shared/common/types/form';

const initialState: TFormStatus = {
  status: EFormStatus.Init,
};

/* istanbul ignore next */
const formSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(sendForm.pending, state => {
        state.status = EFormStatus.Loading;
      })
      .addCase(sendForm.fulfilled, state => {
        state.status = EFormStatus.Success;
      })
      .addCase(sendForm.rejected, state => {
        state.status = EFormStatus.Failed;
      });
  },
  initialState,
  name: 'form',
  reducers: {
    setFormStatus: (state, action: PayloadAction<EFormStatus>) => {
      state.status = action.payload;
    },
  },
});

export const {
  reducer: formReducer,
  actions: { setFormStatus },
} = formSlice;
